import { Collapse as AntdCollapse } from 'antd';
import styled from 'styled-components';

export const Collapse = styled(AntdCollapse)`
    && {
        width: 100%;
        .ant-collapse-header {
            display: flex;
            align-items: center;
            cursor: pointer;
            user-select: none;
            border-radius: 0;

            &:hover {
                background: var(--colors-grey-150, #f1f4f8);
            }
        }

        .ant-collapse-header .ant-collapse-arrow {
            transition: transform 150ms;
        }

        .ant-collapse-item {
            border-bottom: 1px solid var(--neutral-200, #e0e0e0);
        }

        .ant-collapse-content.ant-collapse-content-active > .ant-collapse-content-box {
            padding-left: 32px;
        }

        .ant-collapse-content.ant-collapse-content-inactive > .ant-collapse-content-box {
            padding-left: 32px;
        }
    }
`;
